import {
  Building2,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
} from "lucide-react";
import logo from '../assets/logo-white.png'

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
                <img src={logo} alt="bart-group" className="w-[100px]"/>
             
            </div>
            <p className="text-sm leading-relaxed">
              Воплощаем мечты в реальность с высоким качеством, честностью и
              инновациями с 2009 года.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Услуги</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Строительство домов
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Дизайн
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Ремонт
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Юридическая поддержка
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Недвижимость
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Компания</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  О нас
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Портфолио
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Вакансии
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Блог
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-primaryBlue transition-colors">
                  Контакты
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Связаться</h4>
            <div className="flex gap-4 mb-4">
          
              <a
                href="#"
                className="bg-white/10 p-2 rounded-lg hover:bg-primaryBlue transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              
            </div>
            <p className="text-sm">
              Подписывайтесь в соцсетях, чтобы следить за новостями и идеями.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm">
            &copy; 2024 БАРТ ГРУП. Все права защищены.
          </p>
          {/* <div className="flex gap-6 text-sm">
            <a href="#" className="hover:text-primaryBlue transition-colors">
              Политика конфиденциальности
            </a>
            <a href="#" className="hover:text-primaryBlue transition-colors">
              Условия использования
            </a>
            <a href="#" className="hover:text-primaryBlue transition-colors">
              Политика файлов cookie
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
}
